module.exports = __webpack_public_path__ + "img/11.4f85f268.jpg";